/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');
const fixtures = require('./fixtures');

// Set true for app localized.
const defaultLocale = 'en';
const locales = ['en'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
 // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
 // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
 public: {
   TURBOPACK_BUILD: true,
   LOCALES: locales,
   DEFAULT_LOCALE: defaultLocale,
   FORMAT_MAP: formatMap,
   SITENAME: 'Careers in Defense',
   SITE_DESCRIPTION: 'Your dedicated job board for careers in the defense and defense-tech industries. Secure a vital role in national security. Search and apply today.',
   FRONTENDS: {
     default: 'careersindefense',
   },
   FONTS: {
     OPTIMIZED: true,
   },
   THEME: {
     colors: {
       primary: '#e74410',
       secondary: '#1e1f1d',
     },
   },
   GEO_INFO: {
     fixtures,
   },
   ASSETS: {
     loginImage: '/static/images/login-banner.png',
   },
   BLOG_FEATURE_ACTIVE: true,
   CMP_ID: 'oa82ZwgH6jrQZm',
   LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
   GOOGLE_OAUTH_FEATURE_ACTIVE: true,
   FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
   GA4_MEASUREMENT_IDS: ['G-W3659NJJW4'],
   GOOGLE_MEASUREMENT_API_ENABLED: true,
 },
});
